module.exports = __webpack_public_path__ + "img/Logo_FondoAmarillo_LetrasNegras.904e8dff.svg";